<template>
  <div class="cookies">
    <h1>Cookie Policy</h1>
    <p class="lead">Our <router-link to="/privacy">Privacy Policy</router-link> explains our principles when it comes to the collection, processing and storage of your information. This policy specifically explains how we, our partners deploy cookies, as well as the options you have to control them.</p>

    <h2>TL;DR</h2>
    <p>We use cookies. Either for Google Analytics, or to save your decision (when you close cookie banner). Some cookies are placed by YouTube player (some local, some cross-site) — this is out of our control. To entirely remove all cookies related to this site (wipe out all traces of you visiting it) use tools in your browser.</p>

    <h2>What are cookies?</h2>
    <p>Cookies are small pieces of data, stored in text files, that are stored on your computer or other device when websites are loaded in a browser. They are widely used to "remember" you and your preferences, either for a single visit (through a "session cookie") or for multiple repeat visits (using a "persistent cookie"). They are used to ensure a consistent and efficient experience for visitors, and perform essential functions such as allowing users to register and remain logged in. Cookies may be set by the site that you are visiting (known as "first party cookies"), or by third parties, such as those who serve content or provide advertising or analytics services on the website ("third party cookies"). Both websites and HTML emails may also contain other tracking technologies such as "web beacons" or "pixels." These are typically small transparent images that provide us with statistics, for similar purposes as cookies. They are often used in conjunction with cookies, though they are not stored on your computer in the same way. As a result, if you disable cookies, web beacons may still load, but their functionality may be restricted.</p>

    <h2>How we use cookies</h2>
    <p>We use cookies for a number of different purposes. Some cookies are necessary for technical reasons; some enable a personalized experience for both visitors and registered users; and some allow the display of advertising from selected third party networks. Some of these cookies may be set when a page is loaded, or when a visitor takes a particular action (clicking the "like" button on a post, for example). Some of the cookies we use are only set if you are a registered user (so you don’t have to log in every time, for example), while others are set whenever you visit one of our websites, irrespective of whether you have an account. For more information on the choices you have about the cookies we use, please see the Controlling Cookies section below.</p>

    <h2>Types of Cookie</h2>
    <p class="lead">Below are explained the types of cookies we use on our websites and why we use them.</p>
    <table>
      <tbody>
        <tr>
          <td>Strictly Necessary</td>
          <td><p>These cookies are essential for website of our service to perform its basic functions. These include those required to allow registered users to authenticate and perform account related functions.</p> </td>
        </tr>
        <tr>
          <td>Functionality</td>
          <td>These cookies are used to store preferences set by users such as account name, language.</td>
        </tr>
        <tr>
          <td>Security</td>
          <td>We use these cookies to help identify and prevent potential security risks.</td>
        </tr>
        <tr>
          <td>Analytics and Performance</td>
          <td>Performance cookies collect information on how users interact with our websites, including what pages are visited most, as well as other analytical data. We use these details to improve how our websites function and to understand how users interact with them.</td>
        </tr>
        <tr>
          <td>Third Party / Embedded Content</td>
          <td>We sometimes use different third party applications and services to enhance the experience of website visitors. These include, for example, map. As a result, cookies may be set by these third parties, and used by them to track your online activity. We have no direct control over the information that is collected by these cookies.</td>
        </tr>
      </tbody>
    </table>

    <h2>Examples</h2>
    <p class="lead">Below are examples of the cookies set by us, with explanations of their purpose. Please note that this is not an exhaustive list, but rather aims to be representative.</p>
    <table>
      <tbody>
        <tr>
          <td>_cookie_banner</td>
          <td>Functionality cookie that remembers the state of allowance of usage of ccookies after closing cookie banner</td>
        </tr>
        <tr>
          <td>_ga and _ga_SOME_CODE</td>
          <td>Analytics and Performance cookie set to track activity on our site by Google Ananlytics</td>
        </tr>
      </tbody>
    </table>


    <h2>Controlling Cookies</h2>
    <p>
      <button v-on:click="resetCookies()" type="button">Remove our cookies (reset cookie banner)</button>
    </p>
    <p>To remove all cookies set when you visited our site (including set by third parties) use your browser's built-in tools.</p>
    <p>Visitors may wish to restrict the use of cookies or completely prevent them from being set. Most browsers provide for ways to control cookie behavior such as the length of time they are stored – either through built-in functionality or by utilizing third party plugins. If you disable cookies, please be aware that some of the features of our service may not function correctly.</p>
    <ul>
      To find out more on how to manage and delete cookies, visit <a href="http://aboutcookies.org">aboutcookies.org</a>. For more details on your choices regarding use of your web browsing activity for interest-based advertising you may visit the following sites:
      <li><a href="http://networkadvertising.org/">networkadvertising.org</a></li>
      <li><a href="http://optout.aboutads.info/">optout.aboutads.info </a></li>
      <li><a href="http://youradchoices.com/">youradchoices.com</a></li>
      <li><a href="http://youronlinechoices.eu/">youronlinechoices.eu</a></li>
    </ul>
    <p>On a mobile device, you may also be to adjust your settings to limit ad tracking.</p>

    <h2>Contact Us</h2>
    <p>If you have any questions about our use of cookies, you can find the most relevant contact details in our <router-link to="/privacy">Privacy Policy</router-link>.</p>

    <h2>Change log and effective dates</h2>
    <ul>
      <li>January 25, 2020: Initial Policy Release</li>
    </ul>

  </div>
</template>

<script>
export default {
  methods: {
    resetCookies: function () {
      if (this.$ga) {
        this.$Cookies.remove('_ga', {domain: document.location.hostname, path: '/'})
        this.$Cookies.remove('_ga_'+this.$ga.app.options.measurementId.slice(2,), {domain: document.location.hostname, path: '/'})
      }
      this.$Cookies.remove("_cookie_banner", {domain: document.location.hostname, path: '/'})
      document.querySelector("#cookie-banner").style.display = "block"
    }
  }
}
</script>

<style lang="css" scoped>
button {
  /* margin: 0 0 0 1rem; */
  /* width: 32%; */

  border: none;
  padding: 0.5rem 1rem;
  text-decoration: none;
  /* border-radius: 0.5rem; */
  background-color: #007bff;
  color: #fff;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
}
button:hover {
  background-color: #fff;
  color: #ff0130;
}
button + button {
  margin-left: 1rem;
}
</style>
